export function closeOverlay(evt) {
  if (evt.target.classList.contains("modal")) {
    closeModal(evt.target);
  }
}

export function handleEsc(evt) {
  if (evt.key === "Escape") {
    const openModal = document.querySelector(".modal_opened");
    if (openModal) {
      closeModal(openModal);
    }
  }
}

export function closeModal(evtOrModal) {
  let modal = evtOrModal;
  // If called as an event handler, get the modal element
  if (evtOrModal && evtOrModal.target) {
    modal = document.getElementById("preview-modal");
  }
  if (!modal) return;
  modal.classList.remove("modal_opened");
  modal.removeEventListener("click", closeOverlay);
  document.removeEventListener("keydown", handleEsc);
}
